export default "__VITE_ASSET__orXG$RHL__"